$.fn.changeElementType = function (newType) {
  var attrs = {};
  if (!(this[0] && this[0].attributes)) {
    return;
  }

  $.each(this[0].attributes, function (idx, attr) {
    attrs[attr.nodeName] = attr.value;
  });

  this.replaceWith(function () {
    return $("<" + newType + "/>", attrs).append($(this).contents());
  });
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/util/changeElementType.js